import { useEffect, useState } from 'react'
import { useAuth } from '../auth'

type TelegramWebApp = {
  initData: string
  ready: () => void
  expand: () => void
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp }
  }
}

function loadSdk(): Promise<void> {
  if (window.Telegram?.WebApp) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-web-app.js'
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Telegram 组件没有载入'))
    document.head.appendChild(script)
  })
}

export function TelegramApp() {
  const { loginWithTelegram } = useAuth()
  const [error, setError] = useState('')

  useEffect(() => {
    let stop = false
    loadSdk()
      .then(() => {
        const app = window.Telegram?.WebApp
        if (!app?.initData) {
          if (!stop) setError('请在 Telegram 机器人里点 Open 打开，不要用浏览器直接访问。')
          return
        }
        app.ready()
        app.expand()
        return loginWithTelegram(app.initData)
      })
      .catch((e: Error) => {
        if (!stop) setError(e.message || '没有进入一键完成')
      })
    return () => {
      stop = true
    }
  }, [loginWithTelegram])

  return <div className="center-screen">{error || '正在进入一键完成…'}</div>
}
